import type { Question, QuestionFeedback } from './types';

export type AnswerVisualState = '' | 'selected' | 'correct' | 'incorrect';

export const correctAnswerIds = (question: Question, response: string | null): string[] => {
	if(!response) return [];
	if(question.type === 'tf') {
		return ['true', 't', 'a'].includes(response.toLowerCase()) ? ['t'] : ['f'];
	}
	if(['ms', 'ro'].includes(question.type)) return response.toLowerCase().match(/[a-e]/g) ?? [];
	return [response.toLowerCase()];
};

export const choiceVisualState = (
	question: Question,
	optionId: string,
	selected: string[],
	feedback: QuestionFeedback | null,
	showCorrectResponses: boolean,
): AnswerVisualState => {
	if(!feedback) return selected.includes(optionId) ? 'selected' : '';
	const chosen = selected.includes(optionId);
	const correct = correctAnswerIds(question, feedback.correctResponse).includes(optionId);

	if(feedback.timedOut) return showCorrectResponses && correct ? 'correct' : '';
	if(!showCorrectResponses || !feedback.correctResponse) {
		if(!chosen) return '';
		return feedback.correct ? 'correct' : 'incorrect';
	}
	if(correct) {
		if(question.type === 'ms' && !chosen && !feedback.correct) return 'incorrect';
		return 'correct';
	}
	return chosen ? 'incorrect' : '';
};

export const rankingVisualState = (
	optionId: string,
	position: number,
	feedback: QuestionFeedback | null,
	showCorrectResponses: boolean,
): AnswerVisualState => {
	if(!feedback) return '';
	if(feedback.correct) return 'correct';
	if(!showCorrectResponses || !feedback.correctResponse) return '';
	const order = feedback.correctResponse.toLowerCase().match(/[a-e]/g) ?? [];
	return order[position] === optionId ? 'correct' : 'incorrect';
};

export const moveRankingOption = (order: string[], optionId: string, offset: -1 | 1): string[] => {
	const from = order.indexOf(optionId);
	const to = from + offset;
	if(from < 0 || to < 0 || to >= order.length) return order;
	const nextOrder = [...order];
	nextOrder.splice(to, 0, nextOrder.splice(from, 1)[0]);
	return nextOrder;
};

export const shouldRetryGuess = (timedOut: boolean, correct: boolean, guessNumber: number): boolean =>
	!timedOut && !correct && guessNumber < 3;
